import { LayerDateStep } from '@/enum/LayerDateStep'
import { LayerSourceType } from '@/enum/LayerSourceType'

export class LayerConfig {
  public isBasic: boolean
  public type: LayerSourceType
  public url: string
  public serviceUrl: string
  public layer: string
  public colorscalemin: number | null
  public colorscalemax: number | null
  public colorscaleunit: string
  public colorscaleoffset: number
  public styles: Array<string>
  public defaulStyle: string | null
  public tileMatrix: string | null
  public options: any
  public optionsWmts: any
  public credit: string
  public urlInfo: string
  public canRender: boolean

  constructor({
    isBasic = false,
    type = LayerSourceType.NONE,
    url = '',
    serviceUrl = null as null | string,
    layer = '',
    styles = [],
    defaulStyle = null,
    colorscalemin = null,
    colorscalemax = null,
    colorscaleoffset = 0,
    colorscaleunit = '',
    options = {},
    optionsWmts = null as any,
    credit = '',
    urlInfo = '',
    tileMatrix = null,
  } = {}) {
    this.isBasic = isBasic
    this.url = url
    this.serviceUrl = serviceUrl ?? url
    this.type = type
    this.layer = layer
    this.options = options
    this.optionsWmts = optionsWmts ?? options
    this.styles = styles
    this.defaulStyle = defaulStyle
    this.colorscalemin = colorscalemin == null ? null : Number.parseFloat(colorscalemin!)
    this.colorscalemax = colorscalemax == null ? null : Number.parseFloat(colorscalemax!)
    this.colorscaleoffset = Number.parseFloat((colorscaleoffset ?? 0)?.toString())
    this.colorscaleunit = colorscaleunit
    this.tileMatrix = tileMatrix
    this.credit = credit
    this.urlInfo = urlInfo
    this.canRender = true
    const optionTime = this.options['time']
    if (optionTime) {
      if (optionTime.step == LayerDateStep.MONTH) {
        const startDate = new Date(optionTime.startDate)
        let defaultDate = new Date()
        if (optionTime.endDateTodayOffset < 0) {
          const offsetPicth = 1000 * 60 * 60 * 24
          defaultDate = new Date(defaultDate.getTime() + optionTime.endDateTodayOffset * offsetPicth)
        }
        defaultDate.setUTCDate(startDate.getUTCDate())
        defaultDate.setUTCHours(startDate.getUTCHours())
        defaultDate.setUTCMinutes(startDate.getUTCMinutes())
        defaultDate.setUTCSeconds(startDate.getUTCMinutes())
        defaultDate.setUTCMilliseconds(startDate.getUTCMilliseconds())
        optionTime.default = defaultDate.toISOString()
      } else {
        const startDate = new Date(optionTime.startDate)
        let defaultDate = new Date()
        defaultDate.setUTCHours(startDate.getUTCHours())
        defaultDate.setUTCMinutes(startDate.getUTCMinutes())
        defaultDate.setUTCSeconds(startDate.getUTCMinutes())
        defaultDate.setUTCMilliseconds(startDate.getUTCMilliseconds())
        if (optionTime.endDateTodayOffset < 0) {
          const offsetPicth = optionTime.step == LayerDateStep.HOUR ? 1000 * 60 * 60 : 1000 * 60 * 60 * 24
          defaultDate = new Date(defaultDate.getTime() + optionTime.endDateTodayOffset * offsetPicth)
        }
        optionTime.default = defaultDate.toISOString()
      }
    }
  }
}
